// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3mWyx","content":"ManualTimeModal_content__1zD2C"};